import { render, staticRenderFns } from "./CustomerTypeDelete.vue?vue&type=template&id=65b703ba"
import script from "./CustomerTypeDelete.vue?vue&type=script&lang=js"
export * from "./CustomerTypeDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports